import { Typography, Badge, Progress, Skeleton, Button, Modal } from "antd";
import { SidePanel } from "../../Shared/Components/SidePanel";
import { renderPercentage, assembleStatusTitles } from "../../../utils";
import { api } from "../../../config";
import { useQueries, useQuery } from "react-query";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../interfaces/users";
import TicketAssembly from "./TicketAssembly";
import { toast } from "react-toastify";
import SplitTicket from "../../Shared/Components/SplitTicket";
import ScheduleAssembleEvent from "../../Shared/Components/ScheduleAssembleEvent";
import { useModal } from "../../../utils/hooks/useModal";
import RelatedPendingScheduleTicketsModal from "../../Shared/Components/RelatedPendingScheduleTicketsModal";

const { Title } = Typography;

function ModalContainer({ ticketId }: any) {
  const { token } = useSelector((state: AuthenticationState) => state);
  const [{ isFetching, data, isError, refetch }, {refetch: boardRefetch}]: any = useQueries([
    { queryKey:`tickets/assemble`,
    queryFn: () => api(token).get(`ticket/assemble/${ticketId}`)
  },
    {
      queryKey: "tickets/assemble/board",
      queryFn: () => api(token).get(`tickets/assemble/board`),
      refetchOnMount: false,
    },
]);
  const [editTicketId, setEditTicketId] = useState(false);
  const [formTicketId, setFormTicketId] = useState<number | undefined>(
    undefined
  );

  const [showSplitTicketModal, setShowSplitTicketModal] = useState(false);

  useEffect(() => {
    if (data?.ticketId) {
      setFormTicketId(data.ticketId);
    }
    setEditTicketId(false);
  }, [data, ticketId]);

  const handleEditTicketIdToggle = () => {
    setEditTicketId(!editTicketId);
  };

  const handleSubmitTicketIdChange = async () => {
    try {
      if (!formTicketId) return toast.error("Id inválido");
      await api(token).put(`/ticket/assemble/${ticketId}`, {
        ticketId: formTicketId,
      });
      handleEditTicketIdToggle();
      refetch();
      toast.success("Relatório vinculado com sucesso!");
    } catch (error) {
      toast.error("Ocorreu um erro ao vincular o ID do ticket");
    }
  };

  useEffect(() => {
    if (!isError) {
      refetch();
    }
  }, [isError, refetch, ticketId]);
  const [defaultScheduleTime, setDefaultScheduleTime] = useState<
    Date | undefined
  >(undefined);
  const [agendaModalTicket, setAgendaModalTicket] = useState<any | null>();
  const [relatedScheduleTaxId, setRelatedScheduleTaxId] = useState<
    string | undefined
  >();
  const [relatedScheduleExcludeId, setRelatedScheduleExcludeId] = useState<
    number | undefined
  >();
  const [showRelatedScheduleModal, setShowRelatedScheduleModal] =
    useState(false);
  const { onOpen, onClose, isOpen } = useModal();
  const onClickAgendar = () => {
    if (!data) return;

    if (data.status !== 1) {
      toast.error("O ticket selecionado precisa estar pendente de agendamento");

      return;
    }

    // if (time) {
    //   setDefaultScheduleTime(new Date(time));
    // }

    setAgendaModalTicket({
      ...data,
      products: [
        ...data.products.map((product: any) => ({
          ...product,
          product,
        })),
      ],
    });
    onOpen();
  };

    const handleOk = () => {
    onClose();
    refetch();
    boardRefetch();
  };

  const handleAfterSchedule = (scheduledTicket: any) => {
    setRelatedScheduleTaxId(scheduledTicket?.client?.taxId);
    setRelatedScheduleExcludeId(scheduledTicket?.id);
    setShowRelatedScheduleModal(true);
  };

  if (isFetching) return <Skeleton active />;
  if (isError)
    return (
      <>
        <Title className=" border-b-2  border-slate-100 pb-1 ">
          Erro durante o processo de buscar ticket
        </Title>
      </>
    );
  return (
    <>
        {isOpen && (
        <Modal
          title="Agendar Ticket"
          open={isOpen}
          width={800}
          footer={null}
          onCancel={onClose}
        >
          <ScheduleAssembleEvent
            onSchedule={handleOk}
            defaultDate={defaultScheduleTime}
            onCancel={onClose}
            initialTicket={agendaModalTicket}
            onAfterSchedule={handleAfterSchedule}
          />
        </Modal>
      )}
      <RelatedPendingScheduleTicketsModal
        open={showRelatedScheduleModal}
        taxId={relatedScheduleTaxId}
        excludeId={relatedScheduleExcludeId}
        onClose={() => setShowRelatedScheduleModal(false)}
        onScheduled={() => {
          refetch();
          boardRefetch();
        }}
      />
      <Modal
        open={showSplitTicketModal}
        onCancel={() => setShowSplitTicketModal(false)}
        centered
        width="50%"
        footer={null}
      >
        <SplitTicket ticket={data} />
      </Modal>
      <Badge.Ribbon
        className="px-8 mt-12 mx-2"
        text={assembleStatusTitles[data?.status ?? 1]}
        color={data?.status === 5 ? "red" : "blue"}
      />
      <div className="flex justify-between">
        <Title className=" border-b-2 border-slate-100 pb-1 ">
          {data.title}
        </Title>

        <div className="flex  gap-10 items-center justify-start mr-48">
          {/* <div className=" flex gap-1 items-center justify-center">
            <p className="font-bold">Ticket Medição: </p>
            {editTicketId ? (
              <input
                value={formTicketId}
                onChange={(e) =>
                  setFormTicketId(Number(e.target.value.replace(/\D+/g, "")))
                }
                className="h-6 mr-1 w-10"
                type="text"
              />
            ) : (
              <p> {data.ticketId}</p>
            )}
            <Button
              onClick={
                editTicketId
                  ? handleSubmitTicketIdChange
                  : handleEditTicketIdToggle
              }
            >
              {editTicketId ? "Salvar" : "Editar"}
            </Button>
          </div> */}
          {data?.status === 4 && (
            <div>
              <Button onClick={() => setShowSplitTicketModal(true)}>
                Gerar Ticket Parcial
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="flex">
        <div className="w-1/5">
          <SidePanel
            status={data?.status}
            ticketId={data.id}
            type="assemble"
            ownerId={data.ownerId}
            onClickAgendar={onClickAgendar}
          />
        </div>
        <div className="w-4/5 h-[60vh] overflow-y-scroll">
          <TicketAssembly ticket={data} />
        </div>
      </div>
      <div className="w-11/12 absolute bottom-3">
        <div className="w-full flex justify-center items-center">
          <p className="mr-5">Progresso:</p>
          <Progress
            className="mt-2"
            status={
              data?.status === 4 || data?.status === 9 ? "exception" : "active"
            }
            percent={renderPercentage(data?.status)}
          />
        </div>
      </div>
    </>
  );
}

export default ModalContainer;
